// Résultats d'une équipe : issue d'un match et bilan par compétition.
// Un forfait compte même sans score (la FFBB note souvent 0-0 ou 20-0) ;
// un match à venir ou annulé ne compte pas ; les amicaux restent à part.
import { COMPETITION_LABEL } from './ffbb';

export type Competition = keyof typeof COMPETITION_LABEL;

export interface ResultLike {
  competition: Competition;
  score_us: number | null;
  score_them: number | null;
  forfeit: 'us' | 'them' | null;
  cancelled?: boolean;
  /** D-113 : un 0-0 FFBB non confirmé n'est pas un résultat (calculé par la base). */
  result_confirmed?: boolean;
}

export type Outcome = 'win' | 'loss' | 'draw';

export function outcome(m: ResultLike): Outcome | null {
  if (m.cancelled || m.result_confirmed === false) return null;
  if (m.forfeit === 'them') return 'win';
  if (m.forfeit === 'us') return 'loss';
  if (m.score_us === null || m.score_them === null) return null;
  return m.score_us > m.score_them ? 'win' : m.score_us < m.score_them ? 'loss' : 'draw';
}

export interface Bilan { competition: Competition; label: string; won: number; lost: number; played: number }

const ORDER: Competition[] = ['championnat', 'phase_finale', 'coupe', 'brassage', 'amical'];

/** Bilan par compétition, dans l'ordre utile (championnat d'abord), sans les compétitions vides. */
export function bilan(matches: ResultLike[]): Bilan[] {
  const by = new Map<Competition, Bilan>();
  for (const m of matches) {
    const o = outcome(m);
    if (!o) continue;
    const b = by.get(m.competition) ?? { competition: m.competition, label: COMPETITION_LABEL[m.competition], won: 0, lost: 0, played: 0 };
    b.played++;
    if (o === 'win') b.won++; else if (o === 'loss') b.lost++;
    by.set(m.competition, b);
  }
  return ORDER.filter(c => by.has(c)).map(c => by.get(c)!);
}
